import { render, staticRenderFns } from "./BulkImport.vue?vue&type=template&id=28e52183&scoped=true"
import script from "./BulkImport.vue?vue&type=script&lang=js"
export * from "./BulkImport.vue?vue&type=script&lang=js"
import style0 from "./BulkImport.vue?vue&type=style&index=0&id=28e52183&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e52183",
  null
  
)

export default component.exports